<template>
  <div class="accordion accordion-flush">
    <div class="accordion-item">
      <div
        class="v-item"
        v-if="!configs.children"
        @click="selected($event, configs)"
      >
        {{ configs.name }}
      </div>
      <div
        class="d-flex justify-content-between align-items-center ps-1"
        v-if="configs.children"
        @click.self="selected($event, configs)"
      >
        <span @click="$event.target.parentElement.click()">{{ configs.name }}</span>
        <a
          class="accordion-button collapsed"
          role="button"
          data-bs-toggle="collapse"
          :data-bs-target="'#' + configs.key"
          aria-expanded="false"
        >
        </a>
      </div>
      <div
        v-if="configs.children"
        :id="configs.key"
        class="accordion-collapse collapse"
      >
        <div class="accordion-body">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    configs: Object,
  },
  methods: {
    selected(e, configs) {
      const span = e.target;

      const vItems = document.querySelectorAll(".v-item");
      console.log(vItems)
      vItems.forEach((item) => {
        item.classList.remove("active");
      });

      span.classList.add("active");
      this.$emit("selected", configs);
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion-button {
  padding: 4px 8px 4px 8px;
  font-size: 14px;
  width: 36px;
  &:hover {
    color: #000 !important;
  }
  &::after {
    background-size: 16px;
  }
  &:not(.collapsed) {
    color: unset;
    background-color: transparent;
    box-shadow: unset;
    &::after {
      filter: grayscale(1);
      margin-left: -4px;
    }
  }
}
.accordion-body {
  padding: 0;
}

.v-item {
  padding: 4px 8px;
  padding-left: 16px;
  &:hover {
    background-color: #3b664a;
    color: #fff;
  }
  &.active {
    background-color: #3b664a;
    color: #fff;
  }
}
</style>
